const FilterIasBrandSafeties = [
  { id: 'adt=veryLow', name: 'ADT <= Very Low' },
  { id: 'adt=low', name: 'ADT <= Low' },
  { id: 'adt=medium', name: 'ADT <= Medium' },
  { id: 'adt=high', name: 'ADT <= High' },

  { id: 'alc=veryLow', name: 'ALC <= Very Low' },
  { id: 'alc=low', name: 'ALC <= Low' },
  { id: 'alc=medium', name: 'ALC <= Medium' },
  { id: 'alc=high', name: 'ALC <= High' },

  { id: 'dlm=veryLow', name: 'DLM <= Very Low' },
  { id: 'dlm=low', name: 'DLM <= Low' },
  { id: 'dlm=medium', name: 'DLM <= Medium' },
  { id: 'dlm=high', name: 'DLM <= High' },

  { id: 'drg=veryLow', name: 'DRG <= Very Low' },
  { id: 'drg=low', name: 'DRG <= Low' },
  { id: 'drg=medium', name: 'DRG <= Medium' },
  { id: 'drg=high', name: 'DRG <= High' },

  { id: 'hat=veryLow', name: 'HAT <= Very Low' },
  { id: 'hat=low', name: 'HAT <= Low' },
  { id: 'hat=medium', name: 'HAT <= Medium' },
  { id: 'hat=high', name: 'HAT <= High' },

  { id: 'off=veryLow', name: 'OFF <= Very Low' },
  { id: 'off=low', name: 'OFF <= Low' },
  { id: 'off=medium', name: 'OFF <= Medium' },
  { id: 'off=high', name: 'OFF <= High' },

  { id: 'vio=veryLow', name: 'VIO <= Very Low' },
  { id: 'vio=low', name: 'VIO <= Low' },
  { id: 'vio=medium', name: 'VIO <= Medium' },
  { id: 'vio=high', name: 'VIO <= High' }
]

export default FilterIasBrandSafeties;



// WEBPACK FOOTER //
// ./src/views/StaticData/FilterIasBrandSafeties.tsx